<template>
  <div>
    <header class="container-fluid wfs_menu">
       <div class="container" style="padding:0px" >
          <nav class="navbar navbar-expand-lg navbar-dark">
            <router-link class="navbar-brand" to="/home">
              <img src="/img/logo-topo.png" class="wfs_logo" alt="logo" >
            </router-link>

            <button class="navbar-toggler navbar-toggler-right " v-if="nomeclass!='show'" type="button" data-toggle="collapse" data-target="#navb" @click="abrirNavbar" >
              <span class="navbar-toggler-icon"></span>
            </button>
            <button class="navbar-toggler navbar-toggler-right " v-if="nomeclass=='show'" type="button" data-toggle="collapse" data-target="#navb" @click="fecharNavbar" >
              <span class="navbar-toggler-icon"></span>
            </button>

            <div class="navbar-collapse collapse" :class="nomeclass" id="navb" style="">
              
              <ul class="navbar-nav mr-auto">
              </ul>  
              <form class="form-inline my-2 my-lg-0" id="wfs_itens_menu">
                <ul class="navbar-nav mr-auto">
                  <li class="nav-item ativo-item-menu">
                    <router-link class="nav-link " to="/home">Inicio</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link class="nav-link" to="/manifestacao">Quero fazer uma Manifestação</router-link>
                  </li>
                  <li class="nav-item">
                        <router-link class="nav-link" to="/login">Entrar</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link class="nav-link" to="/registro">Cadastre-se</router-link>
                  </li>
                </ul>
              </form>
            </div>
          </nav>
       </div>  
    </header>
    
        <!--conteudo-->
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
         <!-- fim conteudo-->
    
    <footer class="footer-ouv">
      <div class="container-fluid">
        <nav class="container" style="padding-top: 8px;padding-bottom: 20px;">
          <div class="row">
            <div class="col-md-4">
              <h4 class="footer-titulo-list">Usúario</h4>
              <ul class="footer-menu-lista"> 
                <li class="footer-lista"><router-link to="/login">Entrar</router-link></li>
                <li class="footer-lista"><router-link to="/registro">Cadastre-se</router-link></li>
                <li class="footer-lista"><router-link to="/manifestacao">Quero fazer uma Manifestação</router-link></li>
              </ul>
            </div>
            <div class="col-md-4">
              <h4 class="footer-titulo-list">Anônimo</h4>
              <ul class="footer-menu-lista"> 
                <li class="footer-lista"><router-link to="/manifestacao">Quero fazer uma Manifestação</router-link></li>
              </ul>
            </div>
            <div class="col-md-4">
              <h4 class="footer-titulo-list">Contato</h4>
              <ul class="footer-menu-lista"> 
                <li class="footer-lista"><b>Endereço:</b></li>
                <li class="footer-lista">Av. .....</li>
                <li class="footer-lista" style="padding-top: 10px;"><b>Telefones:</b></li> 
                <li class="footer-lista">Ouvidoria: </li>
                <li class="footer-lista">Prefeitura: </li> 
                <li class="footer-lista">Disque Aglomeração: </li>    
                <li class="footer-lista" style="padding-top: 10px;"><b>E-mails:</b></li>   
                <li class="footer-lista">Ouvidoria: </li>  
                <li class="footer-lista">Prefeitura: </li>
              </ul>
            </div>
          </div>
        </nav>
        <div class="copyright text-center">
             
        </div>
      </div>
    </footer>
  </div>
</template>
<style lang="scss">
  .notifications{
    display:none;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .1s
  }

  .fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */

  {
    opacity: 0
  }

 
</style>

<style>
  .footer-ouv{
    /*margin-top: 35px;*/
    min-height:203px;
    background-color: #e8e8e8;
  }
  .footer-titulo-list{
    font-weight: 700;
  }
  .footer-menu-lista{
    padding: 0;
  }
  .footer-lista{
    list-style:none;
  }
  .footer-lista a{
    color: black !important;
  }
</style>

<script>
  
  
  export default {
    model: {
      event: "abrirNavbar",
      event: "fecharNavbar",
    },
    data() {
      return {
        nomeclass: String,
      }
    },
    methods: {
      abrirNavbar: function () {
        this.$emit("abrirNavbar", this.nomeclass ="show");
      },
      fecharNavbar: function(){
        this.$emit("fecharNavbar", this.nomeclass ="");
      }
    }
  }

</script>
